import { confirmPlayback, getPlayback } from "../api/client";
import { PlaybackCard } from "../components/PlaybackCard";
import type { Stage } from "./Stage0Onramp";

export class Stage3Playback implements Stage {
  private sessionId: string;
  private onConfirmed: () => void;
  private onStartOver: () => void;

  constructor(sessionId: string, onConfirmed: () => void, onStartOver: () => void = () => {}) {
    this.sessionId = sessionId;
    this.onConfirmed = onConfirmed;
    this.onStartOver = onStartOver;
  }

  mount(container: HTMLElement): void {
    container.innerHTML = `
      <div class="progress-header" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" aria-label="Session progress: step 4 of 5">
        <div class="progress-steps">
          <span>Step 4 of 5 — Confirming what I heard</span>
          <div class="progress-bar"><div class="progress-fill" style="width:80%"></div></div>
        </div>
        <div class="header-right">
          <span class="time-est">~2 minutes left</span>
          <button class="btn-ghost btn-start-over" type="button" aria-label="Discard this session and start a new assessment">Start over</button>
        </div>
      </div>

      <div class="playback-card" id="playback-card">
        <p style="color:var(--swo-ash);font-size:13px;">Loading summary...</p>
      </div>

      <div class="playback-actions">
        <button class="btn" id="btn-clarify" type="button">Something's off — let me clarify</button>
        <button class="btn primary" id="btn-confirm" type="button" disabled>
          Looks right — generate my blueprint
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </button>
      </div>
    `;

    this._load(container);

    container.querySelector<HTMLButtonElement>(".btn-start-over")?.addEventListener("click", () => {
      if (window.confirm("Start a new assessment? Your current session will be lost.")) {
        this.onStartOver();
      }
    });
  }

  unmount(): void {}

  private async _load(container: HTMLElement): Promise<void> {
    try {
      const facts = await getPlayback(this.sessionId);
      const card = container.querySelector<HTMLElement>("#playback-card")!;
      new PlaybackCard(card, this.sessionId, facts);

      const confirmBtn = container.querySelector<HTMLButtonElement>("#btn-confirm")!;
      confirmBtn.disabled = false;
      confirmBtn.addEventListener("click", async () => {
        confirmBtn.disabled = true;
        confirmBtn.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" style="animation:spin 1s linear infinite"><circle cx="12" cy="12" r="10" stroke-dasharray="40" stroke-dashoffset="10"/></svg>
          Generating blueprint...
        `;
        try {
          await confirmPlayback(this.sessionId);
          this.onConfirmed();
        } catch {
          confirmBtn.disabled = false;
          confirmBtn.innerHTML = `Looks right — generate my blueprint <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`;
        }
      });
    } catch {
      const card = container.querySelector<HTMLElement>("#playback-card")!;
      card.innerHTML = `<p style="color:var(--swo-red);">Failed to load summary. Please refresh.</p>`;
    }
  }
}
